import React from 'react';
import PropTypes from 'prop-types';
import ExportModalContentDisclaimer from '@Containers/ExportModal/Components/DefaultExportModal/ExportModalContentDisclaimer';
import ExportRouteDialog from '@Pages/RetroSynthesis/ExportRoute/ExportRouteDialog';
import { CONDITIONS_EXPORT_FORMATS, CONDITIONS_EXPORT_FORMATS_TOOLTIP } from '../constants';
import { trackMyProjectsExport2 } from '../analytics';

// FR-4.7: wraps the RetroSynthesis ExportRouteDialog so the Conditions export
// modal stays visually identical to RT without duplicating its layout.
//
const CONDITIONS_EXPORT_TABS = [
  {
    formats: CONDITIONS_EXPORT_FORMATS,
    formatsTooltip: CONDITIONS_EXPORT_FORMATS_TOOLTIP,
  },
];

function ConditionsExportModal({ onClose, onExport, isBusy = false, exportAttempts = {} }) {
  const handleExport = (exportData) => {
    trackMyProjectsExport2();
    if (typeof onExport === 'function') onExport(exportData);
    onClose();
  };

  return (
    <ExportRouteDialog
      onClose={onClose}
      onExport={handleExport}
      tabs={CONDITIONS_EXPORT_TABS}
      isBusy={isBusy}
      isLoading={false}
      disableSelectionOptions
      hideSelectionOptions
      headerText="Export Conditions"
      disclaimer={<ExportModalContentDisclaimer data={exportAttempts} />}
    />
  );
}

ConditionsExportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onExport: PropTypes.func,
  isBusy: PropTypes.bool,
  exportAttempts: PropTypes.shape({
    exportAttemptsLimit: PropTypes.number,
    exportAttemptsCurrentlyUsed: PropTypes.number,
  }),
};

export default ConditionsExportModal;
